export const isVideoUrl = (url: string): boolean => {
  const youtubeRegex =
    /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)/;

  const videoFileRegex = /\.(mp4|webm|ogg|mov|avi|mkv|m4v)(\?.*)?$/i;

  return youtubeRegex.test(url) || videoFileRegex.test(url);
};

export const isYouTubeUrl = (url: string): boolean => {
  const youtubeRegex =
    /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)/;
  return youtubeRegex.test(url);
};

export const extractYouTubeId = (url: string): string => {
  const match = url.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
  );
  return match ? match[1] : "";
};

export const getThumbnailUrl = (url: string): string => {
  if (isYouTubeUrl(url)) {
    const videoId = extractYouTubeId(url);
    return `https://img.youtube.com/vi/${videoId}/0.jpg`;
  }

  if (isVideoUrl(url)) {
    return url;
  }

  return url;
};
